// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"YoutubePlayer_wrapper__v4iUp","player":"YoutubePlayer_player__SE8q4","container":"YoutubePlayer_container__1o1L1"};